/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { CHANGE_USERNAME, ON_CALL_UPLOAD,SET_ITEMS_ERROR, PASS_INV_VAL,PROFILE_INFO, RESET_FETCH_PASS, ON_NOTIFY, LOADER_STATUS, TOTAL_RECORD, GET_ITEM, TOTAL_ITEM_RECORDS, TXN_RECORD, DISABLE_EDIT, SET_PASS_PAGE, EXTEND_DATA,PASS_INV_VAL_MASTER, SET_MODE_AND_GROUP} from './constants';

// The initial state of the App
export const initialState = {
  username: '',
  uploadData: '',
  passData: '',
  passDataMaster:'',
  status: false,
  msg: '',
  loaderStatus: false,
  totalRecords: '',
  itemData: '',
  totalItemRecord: '',
  propsTxnId: '',
  nonEdit: [],
  passPage: 1,
  records: '',
  extendDataVal: '',
  groupNum:[],
  transportMode:[],
  profileData:[],
  itemErrorData:[]
};


/* eslint-disable default-case, no-param-reassign */
const ewayBillGetReducer = (state = initialState, action) =>{
    switch (action.type) {
      case CHANGE_USERNAME:
        return {
          ...state,
          username:action.username.replace(/@/gi, '')
        }
        case SET_ITEMS_ERROR:
          return {
            ...state,
            itemErrorData:action.itemData
          }
      case ON_CALL_UPLOAD:
        return {
          ...state,
          uploadData:action.uploadData
        }
        case PROFILE_INFO:
          return {
            ...state,
            profileData:action.profileData
          }
      case PASS_INV_VAL:
        return {
          ...state,
          passData:action.passData
        }
      case PASS_INV_VAL_MASTER:
        return {
          ...state,
          passDataMaster:action.passDataMaster
        } 
      case RESET_FETCH_PASS:
        return {
          ...state,
          passData:action.passData
        }
      case ON_NOTIFY:
        return {
          ...state,
          status:action.status,
          msg:action.msg
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case TOTAL_RECORD:
        return {
          ...state,
          totalRecords:action.totalRecords,
          records:action.records
        }
      case GET_ITEM:
        return {
          ...state,
          itemData:action.itemData
        }
      case TOTAL_ITEM_RECORDS:
        return {
          ...state,
          totalItemRecord:action.totalItemRecord
        }
      case TXN_RECORD:
        return {
          ...state,
          propsTxnId:action.propsTxnId
        }
      case DISABLE_EDIT:
        return {
          ...state,
          nonEdit:action.nonEdit
        }
      case SET_PASS_PAGE:
        return {
          ...state,
          passPage:action.passPage
        }
      case EXTEND_DATA:
        return {
          ...state,
          extendDataVal:action.extendDataVal
        }
      case SET_MODE_AND_GROUP:
        return {
          ...state,
          groupNum:action.groupNum,
          transportMode:action.transportMode
        }
      default:
        return state;
    }
  };

export default ewayBillGetReducer;
